<template>
    <b-container>
        <b-overlay opacity="0.6" :show="loading">
            <b-card>
                <div class="text-center">
                    <h1 class="h5">Your customer number is:</h1>
                    <h2 class="h1">#{{details.id}}</h2>

                    <img class="img-fluid mb-4" :src="details.qr_code">

                    <p class="text-muted">If you are asked by a member of staff for your customer number, please show them this.</p>
                </div>
            </b-card>
        </b-overlay>
    </b-container>
</template>

<script>
    export default {
        name: "CustomerNumber",

        data(){
            return {
                loading: false,
                details: '',
            }
        },


        mounted() {
            this.getProfileData();
        },


        methods: {
            getProfileData(){
                this.loading = true;
                axios.get('/settings/profile').then(response => {
                    this.details = response.data;
                    console.log(this.details)

                    this.loading = false;
                })
            },
        }
    }
</script>

<style scoped>

</style>